<template>
  <div>
    <h2 class="title is-4 mb-16px has-text-weight-bold" v-if="title">{{ title }}</h2>
    <div v-for="(attribute, idx) in attributes" class="mt-8px" :key="attribute.label || idx">
      <strong class="has-text-weight-semibold is-block">{{ attribute.label }}</strong>
      <span>{{ attribute.value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    attributes: Array
  }
}
</script>
